import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import clientConfig from '../../../etc/client-config.json';
import Cookie from 'js-cookie';
import { translateMissKeyboard } from '../../utils/translate';

import FixedBody from '../../ui/Common/FixedBody';
import { truncText } from '../../utils/formater';

class SelectCityModal extends React.Component {
  constructor (props) {
    super(props);

    this.state = {
      search: '',
      searchList: this.props.domains,
      selectedList: [],
    };

    this.sortAlphabet = this.sortAlphabet.bind(this);
    this.truncRegionName = this.truncRegionName.bind(this);
    this.renderLinks = this.renderLinks.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleClear = this.handleClear.bind(this);
    this.convertCookies = this.convertCookies.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.renderReminder = this.renderReminder.bind(this);
    this.searchSelectedDomains = this.searchSelectedDomains.bind(this);
    this.sortByRank = this.sortByRank.bind(this);
    this.domainsFromCookies = [];
    this.throttlingTimer = null;
  }

  componentDidMount () {
    this.domainsFromCookies = this.convertCookies(Cookie.get('mlsn_domains')) || [];
    this.searchSelectedDomains(this.domainsFromCookies);
  }

  convertCookies (cookie) {
    let domains = [];
    if (typeof(cookie) === 'object') {
      domains = cookie.join(',');
    }
    if (typeof(cookie) === 'string') {
      domains = cookie.split(',');
    }
    return domains;
  }

  searchSelectedDomains(subdomains) {
    let selectedList = [];
    for (const subdomain of subdomains) {
      selectedList.push(this.props.domains.find(i => i.get('domain') === subdomain ));
    }
    this.setState({
      selectedList,
    });
  }

  handleSelect (link) {
    let subdomains = this.domainsFromCookies;
    subdomains.push(link.get('domain'));
    subdomains = [...new Set(subdomains)];
    Cookie.set('mlsn_domains', this.convertCookies(subdomains), { expires: 1095, path: '/', domain: `.${clientConfig.rootDomain}` });
  }

  renderReminder () {
    const { selectedList } = this.state;

    return (
      selectedList.map((i, index) => (
        <a key={index} href={`${clientConfig.protocol}://${i.get('domain')}.${clientConfig.rootDomain}`} onClick={() => this.handleSelect(i)}>
          <div className="select-city__link">
            <span className='select-city__name'>{this.truncRegionName(i.get('cityName'), i.get('regionName'))}</span>
            <span className="select-city__count">{i.get('itemCount')}</span>
          </div>
        </a>
      ))
    )
  }

  sortAlphabet(domains) {
    return this.sortByRank(domains.sort((a, b) => a.get('cityName').localeCompare(b.get('cityName'))));
  }

  sortByRank(domains) {
    return (domains.sort((a, b) => {
      if (a.get('rank') > b.get('rank')) {
        return -1;
      }
      if (a.get('rank') < b.get('rank')) {
        return 1;
      }
      return 0;
    }));
  }

  truncRegionName(cityName, regionName) {
    if (regionName.substring(regionName.length - 2) === ' г') {
      return cityName
    }

    return cityName === regionName ? cityName : truncText(`${cityName} (${regionName})`, 35);
  }

  handleSearch(e) {
    let value = e.target.value;
    this.setState({
      search: value
    });
    clearTimeout(this.throttlingTimer);
    this.throttlingTimer = setTimeout(() => {
      this.setState((state, props) => {
        return {
          searchList: props.domains.filter(i => (
            i.get('cityName').toLowerCase().includes(translateMissKeyboard(value.toLowerCase())) ||
            i.get('regionName').toLowerCase().includes(translateMissKeyboard(value.toLowerCase()))
          )),
        }
      });
    }, 300);
  }

  handleClear() {
    this.setState((state, props) => {
      return {
        search: '',
        searchList: props.domains,
      }
    });
  }

  renderLinks(domains) {
    return (
      domains.size ?
      domains.map((i, index) => (
        <a key={index} href={`${clientConfig.protocol}://${i.get('domain')}.${clientConfig.rootDomain}`} onClick={() => this.handleSelect(i)}>
          <div className="select-city__link">
            <span className='select-city__name'>{this.truncRegionName(i.get('cityName'), i.get('regionName'))}</span>
            <span className="select-city__count">{i.get('itemCount')}</span>
          </div>
        </a>
        )
      )
      :
      (
        <div className='select-city__clear' onClick={this.handleClear}>
          <span>Ничего не найдено.</span>
          <span className='select-city__clear-button'>Очистить поиск</span>
        </div>
      )
    )
  }

  render () {
    const { visible, onClose } = this.props;
    const { search, searchList, selectedList } = this.state;
    return (
      <div className='modal-map'>
        <Modal
          isOpen={visible}
          onRequestClose={onClose}
          portalClassName='select-city-modal'
          className='select-city-modal__content'
          overlayClassName='select-city-modal__overlay'
        >
          <FixedBody />
          <div className='select-city-modal-title'>
            <div className='header'>{'Выберите регион'}</div>
            <button type='button' className='close' onClick={onClose}>×</button>
          </div>

          <div className='select-city-modal-container'>
            <input
              className='text-base'
              autoFocus
              onChange={this.handleSearch}
              type='text'
              placeholder='Поиск'
              value={search}
            />
            {!!selectedList.length &&
              <Fragment>
                <div className='select-city__reminder'>
                  <div className='select-city__reminder-header'>
                    Вы недавно выбирали
                  </div>
                  <div className='select-city__reminder-list'>
                    {this.renderReminder()}
                  </div>
                </div>
                <div className='select-city__container-header'>
                Весь список
                </div>
              </Fragment>
            }

            {this.renderLinks(this.sortAlphabet(searchList))}
          </div>
        </Modal>
      </div>
    );
  }
}

SelectCityModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  domains: PropTypes.object.isRequired,
};

export default SelectCityModal;



// WEBPACK FOOTER //
// ./src/ui/SelectCity/SelectCityModal.jsx